<script>

export default
{
    name: 'eula',

    render () 
    {
        return (
            <div id='eula-view'>
                <div class='title'>Conditions générales d'utilisation</div>
                <div class='agreement'>
                    <h2> Définition des termes </h2>
                    <p> Les termes "Ma Ville" et "l'application" peuvent faire référence à la solution "Ma Ville" ou n'importe quelles autres applications déclinées à partir de la solution "Ma Ville", ainsi qu'à l'entité légale "Ma Ville" qui édite et possède cette solution. </p>
                    <p> Les termes "logiciel" et "application" se référencent mutuellement. </p>
                    
                    <h2> Contrat de licence utilisateur final (CLUF) </h2>
                    
                    <p> Cet accord de licence d'utilisateur final ("CLUF") est un accord juridique entre vous et "Ma Ville". </p>
                    
                    <p> Cet accord de CLUF régit votre acquisition et votre utilisation de notre application ("Application") "Ma Ville" directement depuis une application créée à partir de la solution "Ma Ville" ou indirectement via un revendeur ou distributeur agréé (un "Distributeur"). </p>
                    
                    <p> Veuillez lire attentivement cet accord de CLUF avant d'utiliser la solution "Ma Ville" ou une application déclinée de "Ma Ville". Il fournit une licence d'utilisation de l'application et contient des informations sur la garantie et les exclusions de responsabilité. </p>
                    
                    <p> Si vous vous inscrivez pour un essai gratuit de l'application ou d'une déclinaison de la solution "Ma Ville", cet accord de CLUF régira également cet essai. En cliquant sur "Accepter" ou en installant et / ou en utilisant l'application "Ma Ville" ou l'une de ses déclinaisons, vous confirmez votre acceptation d'être lié par les termes du présent accord de CLUF. </p>
                    
                    <p> En acceptant cet accord vous acceptez aussi notre <a href='/privacy-policy'>politique de confidentialité</a>. </p>
                    
                    <h2>Conditions d'acceptation de cet accord</h2>
                    <p> Si vous concluez cet accord de CLUF au nom d'une société ou d'une autre entité juridique, vous déclarez que vous avez le pouvoir de lier cette entité et ses sociétés affiliées à ces termes et conditions. Si vous ne disposez pas d'une telle autorité ou si vous n'êtes pas d'accord avec les termes et conditions de cet accord de CLUF, n'installez pas ou n'utilisez pas "Ma Ville" ou l'une de ses déclinaisons. </p>
                    
                    <p> Cet accord de CLUF s'applique uniquement aux applications fournies par "Ma Ville", par la présente, indépendamment du fait que d'autres logiciels soient mentionnés ou décrits ici. Les conditions s'appliquent également à toutes les mises à jour, suppléments, services Internet et services d'assistance pour l'application, sauf si d'autres conditions accompagnent ces éléments à la livraison. Dans l'affirmative, ces termes s'appliquent. </p>
                    
                    <h2> Octroi de licence </h2>
                    
                    <p> "Ma Ville" vous accorde par la présente une licence personnelle et / ou dans la mesure ou vous représentez ou faites partie d'une mairie, une licence communale (s'étendant à l'ensemble du personnel communal), non transférable et non exclusive pour utiliser l'application "Ma Ville" sur vos appareils conformément aux termes du présent accord de CLUF. </p>
                    
                    <p> Vous êtes autorisé à télécharger "Ma Ville" ou une de ses déclinaisons sur un appareil (par exemple un PC, un ordinateur portable, un mobile ou une tablette) sous votre contrôle. Vous êtes responsable de vous assurer que votre appareil répond aux exigences minimales de l'application "Ma Ville". </p>
                    
                    <p> Vous n'êtes pas autorisé à: </p>
                    
                    <ul>
                    <li> Éditer, altérer, modifier, adapter, traduir ou autrement changer tout ou une partie du logiciel, ni de le combiner ou l'incorporer dans tout autre logiciel, ni de décompiler, désassembler ou rétroconcevoir le logiciel ou tenter de faire de telles choses </li>
                    <li> Reproduire, copier, distribuer, revendre ou autrement utiliser le logiciel à des fins commerciales </li>
                    <li> Autoriser tout tiers à utiliser le logiciel au nom ou pour le bénéfice d'un tiers sans autorisation préalable de la part de son possesseur légal "Ma Ville" </li>
                    <li> Utiliser le logiciel d'une manière qui enfreint toute loi locale, nationale ou internationale applicable </li>
                    <li> Utiliser le logiciel à toute fin que "Ma Ville" considère comme une violation du présent accord de CLUF </li>
                    </ul>
                    
                    <h2> Propriété intellectuelle et propriétés autres </h2>
                    
                    <p> "Ma Ville" conserve en tout temps la propriété du logiciel tel que vous l'avez téléchargé à l'origine et de tous les téléchargements ultérieurs du logiciel. Le logiciel (et les droits d'auteur et autres droits de propriété intellectuelle de quelque nature que ce soit sur le logiciel, y compris les modifications qui y sont apportées) sont et resteront la propriété de "Ma Ville". </p>
                    
                    <p> "Ma Ville" se réserve le droit d'accorder des licences d'utilisation du logiciel à des tiers sous n'importe quels termes souhaités. </p>
                    
                    <h2> Résiliation </h2>
                    
                    <p> Cet accord de CLUF entre en vigueur à la date à laquelle vous utilisez le logiciel "Ma Ville" ou l'une de ses déclinaisons pour la première fois et se poursuivra jusqu'à sa résiliation. Vous pouvez y mettre fin à tout moment sur notification écrite à "Ma Ville". </p>
                    
                    <p> Il prendra également fin immédiatement si vous ne respectez pas l'une des conditions de cet accord de CLUF. En cas de résiliation, les licences accordées par cet accord de CLUF prendront immédiatement fin et vous vous engagez à cesser tout accès et utilisation du logiciel. Les dispositions qui, par leur nature, continuent et survivent survivront à toute résiliation de cet accord de CLUF. </p>
                    
                    <h2> Loi applicable </h2>
                    
                    <p> Cet accord de CLUF, et tout litige découlant de ou en relation avec cet accord de CLUF, sera régi et interprété conformément aux lois françaises.</p>
                </div>
            </div>
        )
    },

    data () 
    {
        return {
        }
    },

    mounted ()
    {
    },

    methods:
    {
    },

    components:
    {
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

#eula-view
{
    width: 100%;
    padding-top: 15vh;

    & .title
    {
        width: 100%;
        margin-left: auto;
        margin-right: auto;
        text-align: center;
        font-size: 6vw;

        .OnTablet({ font-size: 4.5vw; });
        .OnDesktop({ font-size: 2vw; });
    }

    & .agreement
    {
        margin-top: 10vh;
        margin-bottom: 10vh;
        width: 90%;
        margin-left: 5%;

        .OnTablet({
            width: 70%;
            margin-left: 15%;
        });

        .OnDesktop({
            width: 60%;
            margin-left: 20%;
        });

        h2
        {
            margin: 2vh 0;
        }

        a, b
        {
            color: var(--theme-accent-color);
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/Eula.vue